module.exports = __webpack_public_path__ + "static/media/in-flat-white.392b2431.png";